var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "all_discuss_wrap" },
    [
      _c("div", { staticClass: "all_discuss_title" }, [
        _c("div", { staticClass: "all_discuss_tab" }, [
          _c("img", {
            attrs: {
              src: require("../../../../../../../static/images/study/icon/luntan_hv.png")
            }
          }),
          _vm._v(" "),
          _c("h2", [_vm._v(_vm._s(_vm.currentRouter))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "all_discuss_title_right" }, [
          _vm.currentRouter == "全部讨论区"
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "discuss_search" },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入讨论主题、回复或评论" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.discussSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.discussSearchValue,
                          callback: function($$v) {
                            _vm.discussSearchValue = $$v
                          },
                          expression: "discussSearchValue"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", {
                        attrs: { icon: "el-icon-search" },
                        on: { click: _vm.discussSearch }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "send_discuss",
                      on: { click: _vm.addDiscuss }
                    },
                    [_vm._v("发起讨论")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentRouter != "全部讨论区"
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "send_discuss",
                      on: { click: _vm.backBiscuss }
                    },
                    [_vm._v("返 回")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.currentRouter == "全部讨论区"
        ? _c("discussList", {
            attrs: {
              discussList: _vm.discussList,
              introduce: _vm.introduce,
              isOwnValue: _vm.ownValue,
              region: _vm.region,
              pageTotal: _vm.pageTotal
            },
            on: {
              toClass: _vm.listSwitch,
              changeSwitch: _vm.changeSwitch,
              jumpDetails: _vm.jumpDetails,
              currentPageFn: _vm.currentPageFn
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouter == "发起讨论" || _vm.currentRouter == "编辑讨论"
        ? _c("initiateDiscussion", {
            attrs: {
              region: _vm.detailsRegion,
              isTopNum: _vm.isTopNum,
              editDetailsInfo: _vm.editDetailsInfo
            },
            on: { publish: _vm.publish }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentRouter == "主题详情" && _vm.detailsId != null
        ? _c("themeDetails", {
            attrs: { region: _vm.detailsRegion, detailsId: _vm.detailsId },
            on: { changeRouter: _vm.changeRouter }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4df5d4f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df5d4f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/discuss/allDiscuss/allDiscuss.vue
// module id = null
// module chunks = 